module.exports = require("@modelcontextprotocol/sdk/server/stdio.js");